import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { loading, isAuthed } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#070707] text-white/40 flex items-center justify-center">
        <span className="text-[10px] tracking-[0.32em] uppercase">Učitavanje...</span>
      </div>
    );
  }
  if (!isAuthed) return <Navigate to="/admin/login" replace />;
  return children;
}
